<template>
<div class="chapter">
<div class="inner_page">
<p class="h2c">Contents</p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter1">Chapter One. “Ed Morrow Plain Makes Me Sick to My Stomach”</a></p>
<p class="toc1"><span href="#/chapter2" title="Link target outside of Sample">Chapter Two. Governors and Their Kith and Kin</span></p>
<p class="toc1"><span href="#/chapter3" title="Link target outside of Sample">Chapter Three. Kentuckians in the National Capital (and Their Relations)</span></p>
<p class="toc1"><span href="#/chapter4" title="Link target outside of Sample">Chapter Four. State Solons and Others</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?27715852